module.exports = __webpack_public_path__ + "static/1-5a5d68b5cbcf137189e9f1c419ccbd47.svg";